import script from "./DocsBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./DocsBreadcrumb.vue?vue&type=style&index=0&id=51607326&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51607326"]])

export default __exports__